/**
 * Firebase Configuration for SURGE Expiry Tracker
 * GDPR-Compliant Stock Tracker with Cross-Device Sync
 */

// Firebase configuration from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyAHAtVh0aI4BwolpFQwjb9kwgKSnU36xHI",
  authDomain: "surge-expiry-tracker.firebaseapp.com",
  projectId: "surge-expiry-tracker",
  storageBucket: "surge-expiry-tracker.firebasestorage.app",
  messagingSenderId: "295441082916",
  appId: "1:295441082916:web:d475d1d592cf431f6846b1",
  measurementId: "G-4SQYL6XQNH"
};

// Initialize Firebase (will be called from batch-checker.js)
let firebaseApp = null;
let firestoreDb = null;
let firebaseAuth = null;

async function initializeFirebase() {
  try {
    // Check if Firebase SDK is loaded
    if (typeof firebase === 'undefined') {
      console.error('Firebase SDK not loaded');
      return false;
    }

    // Initialize Firebase app
    if (!firebaseApp) {
      firebaseApp = firebase.initializeApp(firebaseConfig);
      firestoreDb = firebase.firestore();
      firebaseAuth = firebase.auth();
      
      console.log('Firebase initialized successfully');
    }

    return true;
  } catch (error) {
    console.error('Error initializing Firebase:', error);
    return false;
  }
}

// Export for use in other files
window.FirebaseConfig = {
  initialize: initializeFirebase,
  getApp: () => firebaseApp,
  getDb: () => firestoreDb,
  getAuth: () => firebaseAuth,
  config: firebaseConfig
};